import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=a57e3c08&scoped=true&"
import script from "./Configurator.vue?vue&type=script&lang=js&"
export * from "./Configurator.vue?vue&type=script&lang=js&"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=a57e3c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57e3c08",
  null
  
)

export default component.exports